import { queryOptions } from "@tanstack/vue-query";
import { handleClientMethod } from "@saflib/sdk";
import { getClient } from "../../client.ts";
import type { PowerUpServiceResponseBody } from "@vendata/power-up-spec";

export const ledgerCreditsQuery = () => {
  return queryOptions({
    queryKey: ["credits", "ledger"],
    queryFn: async (): Promise<
      PowerUpServiceResponseBody["ledgerCredits"][200]
    > => {
      return handleClientMethod(getClient().GET("/credits/ledger"));
    },
  });
};
